import React from 'react';
import { makeStyles } from '@material-ui/core';
import { COLORS } from './data';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
    background: 'white',
    border: '1px solid rgba(51,177,225,0.2)',
    borderLeft: `4px solid ${COLORS.blue}`,
    borderRadius: 12,
    padding: '12px 14px',
    marginBottom: 14,
  },
  img: {
    width: 38,
    height: 38,
    objectFit: 'contain',
    flexShrink: 0,
    marginTop: 2,
  },
  msg: {
    fontSize: 13,
    color: COLORS.ink,
    lineHeight: 1.5,
    '& strong': {
      color: COLORS.blue,
      fontWeight: 700,
    },
  },
}));

export default function ZipiTip({ message }) {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <img className={classes.img} src="img/zipi.png" alt="Zipi" />
      {/* eslint-disable-next-line react/no-danger */}
      <div className={classes.msg} dangerouslySetInnerHTML={{ __html: message }} />
    </div>
  );
}
